export default __webpack_public_path__ + "assets/img/cost_comparison_xl_lg.svg";